<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row">
      <div class="col-6">
        <h1>Pedidos</h1>
      </div>
      <div class="col-6 text-end">
        <router-link v-show="isAdmin" to="/showcase/settings">
          <button class="btn btn-outline-primary mt-3"><i class="bi bi-shop me-2"></i>Configurar vitrine</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item" v-for="tab in tabs" :key="tab.value">
        <a href="#" class="nav-link" :class="{ active: filtro === tab.value }" @click.prevent="setFiltro(tab.value)">
          {{ tab.label }}
        </a>
      </li>
    </ul>

    <app-table v-if="!loading" :empty="lista.length === 0" empty-message="Nenhum pedido encontrado."
    :colunas="[{ label: 'Código' }, { label: 'Cliente' }, { label: 'Data da festa' }, { label: 'Total', align: 'right' }, { label: 'Status' }, { label: '' }]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.code},
          {value: item.customer_name, type: 'avatar', sub: item.customer_phone},
          {value: dateFormat.dateTime(item.event_date_start)},
          {value: money(item.total), align: 'right'},
          {type: 'badge', label: statusLabel(item.status), ...statusStyle(item.status)}
        ]"
      >
      <template #actions>
        <button class="btn btn-sm btn-primary" @click="abrir(item)">
          <i class="bi bi-eye me-2"></i>Abrir
        </button>
      </template>
      </app-trow>
    </app-table>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Modal de detalhes -->
    <div class="modal fade" id="modal_order" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content" v-if="pedido">
          <div class="modal-header">
            <h5 class="modal-title">
              Pedido {{ pedido.code }}
              <span class="badge ms-2" :style="{ background: statusStyle(pedido.status).bg, color: statusStyle(pedido.status).text }">{{ statusLabel(pedido.status) }}</span>
            </h5>
            <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <h6 class="text-muted mb-1">Cliente</h6>
                <div><strong>{{ pedido.customer_name }}</strong></div>
                <div>
                  {{ pedido.customer_phone }}
                  <a :href="whatsappCliente(pedido.customer_phone)" target="_blank" rel="noopener" class="ms-2 text-success">
                    <i class="bi bi-whatsapp"></i> conversar
                  </a>
                </div>
                <div v-if="pedido.customer_email">{{ pedido.customer_email }}</div>
              </div>
              <div class="col-md-6">
                <h6 class="text-muted mb-1">Festa</h6>
                <div>{{ dateFormat.dateTime(pedido.event_date_start) }} até {{ dateFormat.dateTime(pedido.event_date_end) }}</div>
                <div v-if="pedido.payment_method === 'PIX'"><i class="bi bi-qr-code me-1"></i>Pagamento via Pix</div>
                <div v-if="pedido.withdrawal"><i class="bi bi-person-walking me-1"></i>Cliente retira no local</div>
                <div v-else><i class="bi bi-truck me-1"></i>{{ endereco(pedido) }}</div>
              </div>
            </div>

            <div class="d-flex flex-wrap justify-content-between align-items-end gap-2 mt-4 mb-2">
              <h6 class="text-muted mb-0">Itens</h6>
              <div v-if="!bloqueado" class="d-flex flex-wrap align-items-end gap-2">
                <div>
                  <label class="form-label small mb-1" for="selTabela">Tabela de preço</label>
                  <select v-model="tabelaSelecionada" class="form-select form-select-sm" id="selTabela">
                    <option :value="null">Preços da vitrine</option>
                    <option v-for="t in tabelas" :key="t.id" :value="t.id">{{ t.name }}</option>
                  </select>
                </div>
                <button type="button" class="btn btn-sm btn-outline-primary" @click="aplicarTabela"
                  :disabled="acaoLoading || tabelaSelecionada === (pedido.id_price_table ?? null)">
                  Aplicar
                </button>
              </div>
            </div>
            <div v-if="enviarValores && pedido.customer_whatsapp_url" class="alert alert-success d-flex flex-wrap align-items-center justify-content-between gap-2 py-2">
              <span><i class="bi bi-check2-circle me-1"></i>Valores atualizados. Envie os novos preços para o cliente.</span>
              <a :href="pedido.customer_whatsapp_url" target="_blank" rel="noopener" class="btn btn-sm btn-success" @click="enviarValores = false">
                <i class="bi bi-whatsapp me-1"></i>Enviar pelo WhatsApp
              </a>
            </div>
            <table class="table table-sm">
              <thead><tr><th>Item</th><th class="text-center">Qtd</th><th class="text-end">Unitário</th><th class="text-end">Total</th></tr></thead>
              <tbody>
                <tr v-for="combo in pedido.combos" :key="'c' + combo.id">
                  <td>
                    <span class="badge text-bg-light border me-1">Combo</span>{{ combo.name }}
                    <div class="small text-muted">{{ resumoCombo(combo) }}</div>
                  </td>
                  <td class="text-center">{{ combo.quantity }}</td>
                  <td class="text-end">{{ money(combo.unit_price) }}</td>
                  <td class="text-end">{{ money(combo.total_amount) }}</td>
                </tr>
                <tr v-for="linha in pedido.items" :key="linha.id">
                  <td>{{ linha.item?.name ?? 'Item removido' }}</td>
                  <td class="text-center">{{ linha.quantity }}</td>
                  <td class="text-end">{{ money(linha.unit_price) }}</td>
                  <td class="text-end">{{ money(linha.total_amount) }}</td>
                </tr>
              </tbody>
            </table>

            <div class="row g-3 align-items-end">
              <div class="col-md-3">
                <label class="form-label">Subtotal</label>
                <input class="form-control" :value="money(pedido.subtotal)" disabled>
              </div>
              <div class="col-md-3">
                <label class="form-label" for="txtFreight">Frete <small v-if="pedido.freight_rule" class="text-muted">({{ regraFrete(pedido) }})</small></label>
                <input v-model="edicao.freight" :disabled="bloqueado" type="number" step="0.01" min="0" class="form-control" id="txtFreight">
              </div>
              <div class="col-md-3">
                <label class="form-label" for="txtDiscount">Desconto</label>
                <input v-model="edicao.discount" :disabled="bloqueado" type="number" step="0.01" min="0" class="form-control" id="txtDiscount">
              </div>
              <div class="col-md-3">
                <label class="form-label">Total</label>
                <input class="form-control fw-bold" :value="money(totalCalculado)" disabled>
              </div>
              <div class="col-12">
                <label class="form-label" for="txtNote">Observação</label>
                <textarea v-model="edicao.note" :disabled="bloqueado" class="form-control" id="txtNote" rows="2"></textarea>
              </div>
            </div>

            <div v-if="pedido.id_rental" class="alert alert-success mt-3 mb-0">
              Convertido na locação
              <router-link :to="{ path: '/rental/details', query: { id: pedido.id_rental } }" @click="closeModal">#{{ pedido.rental?.code ?? pedido.id_rental }}</router-link>.
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <button v-show="isAdmin" type="button" @click="excluir" :disabled="acaoLoading" class="btn btn-outline-danger">
                <i class="bi bi-trash me-1"></i>Excluir
              </button>
            </div>
            <div v-if="!bloqueado" class="d-flex flex-wrap gap-2">
              <a v-if="pedido.customer_whatsapp_url" :href="pedido.customer_whatsapp_url" target="_blank" rel="noopener" class="btn btn-outline-success" title="Envia ao cliente os valores salvos do pedido">
                <i class="bi bi-whatsapp me-1"></i>Enviar valores
              </a>
              <button type="button" @click="salvar" :disabled="acaoLoading" class="btn btn-secondary">Salvar ajustes</button>
              <button v-if="pedido.status === 'NEW'" type="button" @click="mudarStatus('NEGOTIATING')" :disabled="acaoLoading" class="btn btn-outline-primary">Em negociação</button>
              <button v-if="pedido.status !== 'REJECTED'" type="button" @click="mudarStatus('REJECTED')" :disabled="acaoLoading" class="btn btn-outline-danger">Recusar</button>
              <button v-if="pedido.status === 'REJECTED'" type="button" @click="mudarStatus('NEGOTIATING')" :disabled="acaoLoading" class="btn btn-outline-primary">Reabrir</button>
              <button v-if="pedido.status !== 'REJECTED'" type="button" @click="converter" :disabled="acaoLoading" class="btn btn-success">
                <span v-if="acaoLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <i v-else class="bi bi-check2-circle me-1"></i>Confirmar e gerar locação
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { Modal } from "bootstrap";
import { orders } from '@/models/orders';
import { itens } from '@/models/itens';
import { tableprice } from '@/models/tableprice';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import dateFormat from '@/services/dateFormat';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

const STATUS = {
  NEW:         { label: 'Novo',           bg: '#fff4e5', text: '#a15c00', dot: '#f59e0b' },
  NEGOTIATING: { label: 'Em negociação',  bg: '#e8f1ff', text: '#1d4ed8', dot: '#3b82f6' },
  CONFIRMED:   { label: 'Confirmado',     bg: '#e7f7ee', text: '#15803d', dot: '#22c55e' },
  REJECTED:    { label: 'Recusado',       bg: '#f3f4f6', text: '#6b7280', dot: '#9ca3af' },
};

export default {
  name: "OrdersView",
  components: {
    PainelLayout,
    Breadcrumb,
    AppTable, AppTrow
  },
  setup() {

    const toastStore = useToastStore();
    const router = useRouter();
    const model = orders();
    const { isAdmin, isUser, isOpeto } = usePermissions();

    const tabs = [
      { label: 'Precisam de resposta', value: 'NEW' },
      { label: 'Em negociação', value: 'NEGOTIATING' },
      { label: 'Confirmados', value: 'CONFIRMED' },
      { label: 'Recusados', value: 'REJECTED' },
      { label: 'Todos', value: null },
    ];

    const lista = ref([]);
    const filtro = ref('NEW');
    const loading = ref(false);
    const acaoLoading = ref(false);
    const pedido = ref(null);
    const edicao = reactive({ freight: 0, discount: 0, note: '' });
    const tabelas = ref([]);
    const tabelaSelecionada = ref(null);
    const enviarValores = ref(false);
    let modal = null;

    const bloqueado = computed(() => !!pedido.value?.id_rental);
    const totalCalculado = computed(() => {
      if (!pedido.value) return 0;
      return Math.max(0, Number(pedido.value.subtotal) + Number(edicao.freight || 0) - Number(edicao.discount || 0));
    });

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list(filtro.value);
      } catch (error) {
        toastStore.error('Erro ao carregar pedidos: ' + parseError(error));
      }
      loading.value = false;
    }

    function setFiltro(valor) {
      filtro.value = valor;
      list();
    }

    function preencher(dados) {
      pedido.value = dados;
      edicao.freight = Number(dados.freight);
      edicao.discount = Number(dados.discount);
      edicao.note = dados.note ?? '';
      tabelaSelecionada.value = dados.id_price_table ?? null;
    }

    async function abrir(item) {
      try {
        enviarValores.value = false;
        preencher(await model.getOne(item.id));
        modal = new Modal(document.getElementById('modal_order'));
        modal.show();
      } catch (error) {
        toastStore.error('Erro ao abrir pedido: ' + parseError(error));
      }
    }

    function closeModal() {
      if (modal) modal.hide();
    }

    async function executar(acao, mensagem) {
      acaoLoading.value = true;
      try {
        await acao();
        toastStore.success(mensagem);
        list();
      } catch (error) {
        toastStore.error(parseError(error));
      }
      acaoLoading.value = false;
    }

    function salvar() {
      return executar(async () => {
        await model.update({ id: pedido.value.id, ...edicao });
        preencher(await model.getOne(pedido.value.id));
      }, 'Pedido atualizado.');
    }

    // Salva frete/desconto/observação digitados e aplica a tabela; depois oferece o envio ao cliente
    function aplicarTabela() {
      return executar(async () => {
        await model.update({ id: pedido.value.id, ...edicao });
        preencher(await model.applyPriceTable(pedido.value.id, tabelaSelecionada.value));
        enviarValores.value = true;
      }, tabelaSelecionada.value ? 'Tabela de preço aplicada.' : 'Preços da vitrine restaurados.');
    }

    function mudarStatus(status) {
      return executar(async () => {
        await model.updateStatus(pedido.value.id, status);
        preencher(await model.getOne(pedido.value.id));
      }, 'Status atualizado.');
    }

    function converter() {
      if (!confirm('Confirmar o pedido e gerar a locação? A disponibilidade será conferida de novo.')) return;
      return executar(async () => {
        // Salva frete/desconto antes, para a locação sair com o valor negociado
        await model.update({ id: pedido.value.id, ...edicao });
        const res = await model.convert(pedido.value.id);
        closeModal();
        router.push({ path: '/rental/details', query: { id: res.id_rental } });
      }, 'Locação gerada a partir do pedido.');
    }

    function excluir() {
      if (!confirm('Excluir este pedido? Esta ação não pode ser desfeita.')) return;
      return executar(async () => {
        await model.delet(pedido.value.id);
        closeModal();
      }, 'Pedido excluído.');
    }

    // Nomes dos itens de um combo (a composição é guardada no pedido só com ids)
    const nomesItens = ref({});
    function resumoCombo(combo) {
      return (combo.items || []).map(ci => `${ci.quantity}x ${nomesItens.value[ci.id_item] ?? 'item #' + ci.id_item}`).join(', ');
    }

    const REGRAS_FRETE = {
      free_above: 'grátis pelo valor',
      city: 'preço da cidade',
      free_radius: 'raio grátis',
      distance: 'por km',
      unavailable: 'a combinar',
      disabled: 'a combinar',
      manual: 'ajustado',
    };
    function regraFrete(p) {
      const regra = REGRAS_FRETE[p.freight_rule] ?? p.freight_rule;
      return p.distance_km ? `${regra}, ${Number(p.distance_km).toLocaleString('pt-BR')} km` : regra;
    }

    function statusLabel(status) {
      return STATUS[status]?.label ?? status;
    }

    function statusStyle(status) {
      const s = STATUS[status] ?? STATUS.REJECTED;
      return { bg: s.bg, text: s.text, dot: s.dot };
    }

    function money(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function endereco(p) {
      return [p.address, p.number, p.neighbor, p.city, p.state].filter(Boolean).join(', ') || 'Endereço não informado';
    }

    function whatsappCliente(telefone) {
      let numero = String(telefone || '').replace(/\D/g, '');
      if (numero.length <= 11) numero = '55' + numero;
      return 'https://wa.me/' + numero;
    }

    onMounted(async () => {
      list();
      try {
        const todos = await itens().list();
        nomesItens.value = Object.fromEntries(todos.map(i => [i.id, i.name]));
      } catch (e) {
        // só afeta a descrição dos combos
      }
      try {
        tabelas.value = await tableprice().list();
      } catch (e) {
        // sem tabelas, fica só a opção "Preços da vitrine"
      }
    });

    return {
      tabs, lista, filtro, loading, acaoLoading, pedido, edicao, bloqueado, totalCalculado,
      tabelas, tabelaSelecionada, enviarValores,
      setFiltro, abrir, closeModal, salvar, aplicarTabela, mudarStatus, converter, excluir,
      statusLabel, statusStyle, money, resumoCombo, regraFrete, endereco, whatsappCliente, dateFormat,
      isAdmin, isUser, isOpeto
    }
  }
}
</script>
